/* unplugin-vue-components disabled */import { render } from "./WxCheck.vue?vue&type=template&id=aa66929e&scoped=true"
import script from "./WxCheck.vue?vue&type=script&lang=js"
export * from "./WxCheck.vue?vue&type=script&lang=js"

import "./WxCheck.vue?vue&type=style&index=0&id=aa66929e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa66929e"]])

export default __exports__